module.exports = __webpack_public_path__ + "static/media/dev_website.8e7bb317.jpg";